import { Info } from "lucide-react"

import { Card, CardContent } from "@/components/ui/card"
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip"
import { cn } from "@/lib/utils"

interface StatisticProps {
  label: string
  value: string | number
  tooltip?: string
  className?: string
  onClick?: () => void
}

export function Statistic({
  label,
  value,
  tooltip,
  className,
  onClick,
}: StatisticProps) {
  return (
    <Card
      className={cn(
        "py-4 shadow-none transition-shadow",
        onClick && "cursor-pointer hover:shadow-sm",
        className,
      )}
      onClick={onClick}
    >
      <CardContent className="px-4 py-0">
        <div className="mb-2 flex items-center justify-between gap-2">
          <span className="text-muted-foreground text-sm font-medium">
            {label}
          </span>
          {tooltip && (
            <Tooltip>
              <TooltipTrigger asChild>
                <Info className="text-muted-foreground size-4 cursor-help" />
              </TooltipTrigger>
              <TooltipContent>
                <p>{tooltip}</p>
              </TooltipContent>
            </Tooltip>
          )}
        </div>
        <div className="text-2xl font-semibold">{value}</div>
      </CardContent>
    </Card>
  )
}
